import React, { useState, useEffect } from 'react';
import { Github, Linkedin, Mail, ChevronDown } from 'lucide-react';
import { personalInfo as mockInfo } from '@/mock';
import '@/styles/HeroSection.css';

const DEFAULT_RESUME_URL = 'https://customer-assets.emergentagent.com/job_9a78ead3-1f22-4c21-9aa3-d585cea0e3dd/artifacts/aorg71l4_Ahmad%20Kassabieh%20-%20Resume.pdf';

const HeroSection = ({ settings, loading }) => {
  const [displayText, setDisplayText] = useState('');
const roles = [
  'Senior Mobile Engineer',
  'Flutter & iOS Specialist',
  'Fintech Architect',
  'Mobile Team Lead',
  'CSPO-Accredited'
];
  const [currentRoleIndex, setCurrentRoleIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  // Use settings from API or fallback to mock
  const info = settings || mockInfo;
  const resumeUrl = settings?.resumeUrl || DEFAULT_RESUME_URL;

  useEffect(() => {
    const currentRole = roles[currentRoleIndex];
    const timeout = setTimeout(() => {
      if (!isDeleting) {
        if (displayText.length < currentRole.length) {
          setDisplayText(currentRole.substring(0, displayText.length + 1));
        } else {
          setTimeout(() => setIsDeleting(true), 2000);
        }
      } else {
        if (displayText.length > 0) {
          setDisplayText(currentRole.substring(0, displayText.length - 1));
        } else {
          setIsDeleting(false);
          setCurrentRoleIndex((prevIndex) => (prevIndex + 1) % roles.length);
        }
      }
    }, isDeleting ? 50 : 100);

    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayText, isDeleting, currentRoleIndex]);

  const scrollToAbout = () => {
    document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
  };

  // Extract stats from settings or use defaults
  const stats = settings?.stats || { years: '6+', users: '30M+', projects: '50+' };

  return (
    <section className="hero-section" id="home">
      <div className="hero-background">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
        <div className="gradient-orb orb-3"></div>
      </div>

      <div className="hero-content">
        <div className="hero-glass-card">
          <div className="hero-text">
            <div className="hero-greeting">Hello, I'm</div>
            <h1 className="hero-name">{info.name}</h1>
            <div className="hero-role">
              <span className="role-text">{displayText}</span>
              <span className="cursor-blink">|</span>
            </div>
            <p className="hero-tagline">{info.tagline}</p>

            <div className="hero-stats">
              <div className="stat-item">
                <div className="stat-value">{stats.years}</div>
                <div className="stat-label">Years Exp</div>
              </div>
              <div className="stat-item">
                <div className="stat-value">{stats.users}</div>
                <div className="stat-label">Users</div>
              </div>
              <div className="stat-item">
                <div className="stat-value">{stats.projects}</div>
                <div className="stat-label">Projects</div>
              </div>
            </div>

{/*             <div className="hero-actions"> */}
{/*               <button className="btn-primary" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}> */}
{/*                 Get In Touch */}
{/*               </button> */}
{/*               <button className="btn-secondary" onClick={() => window.open(resumeUrl, '_blank')}> */}
{/*                 View Resume */}
{/*               </button> */}
{/*             </div> */}

            <div className="hero-social">
              <a href={info.github} target="_blank" rel="noopener noreferrer" className="social-link">
                <Github size={20} />
              </a>
              <a href={info.linkedin} target="_blank" rel="noopener noreferrer" className="social-link">
                <Linkedin size={20} />
              </a>
              <a href={`mailto:${info.email}`} className="social-link">
                <Mail size={20} />
              </a>
            </div>
          </div>
        </div>

        <button className="scroll-indicator" onClick={scrollToAbout}>
          <ChevronDown size={32} className="bounce" />
        </button>
      </div>
    </section>
  );
};

export default HeroSection;